import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from '../../../../../environments/environment.prod';
import { NgForm } from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { UserService } from '../UserDetails/user.service';
import { UserProfile } from '../UserDetails/user.profile';
import { IProfile } from '../UserDetails/user.model';
import { Notification } from '../../../../core/Notifications/Notification';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { GlobalStorage } from '../../../../core/Gloabl/Global';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { AlertComponent } from '../alert/alert.component';
import { MatDialog } from '@angular/material/dialog';
import { utf8Encode } from '@angular/compiler/src/util';
import { MatCheckboxChange, MAT_CHECKBOX_DEFAULT_OPTIONS } from '@angular/material/checkbox';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  setCheckbox=false;
  loginform:FormGroup;
  clientId='Global_spa';
  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  
  phide = true;
  // hide = true;
  constructor(private fb: FormBuilder,
    private router: Router, private Http: HttpClient, private notify: Notification
    , private global: GlobalStorage,private authProfile: UserProfile,private _snackBar: MatSnackBar,
    public dialog: MatDialog) {
      
    
    this.loginform=this.fb.group({
      'username':['',[Validators.pattern("[0-9]{10}$"), this.nameValidator, Validators.minLength(10), Validators.maxLength(10), Validators.required]],
      'password':['',[Validators.required,Validators.minLength(6)]],
      
    })
    
  }
  public checkError = (controlName: string, errorName: string) => {
    return this.loginform.controls[controlName].hasError(errorName);
  }

  ngOnInit(): void {
    if(this.setCheckbox==true)
    {
      
    }
    
    
  }

  nameValidator(control: any): { [key: string]: boolean } {
    const nameRegexp: RegExp = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?/\s/g,''/a-zA-Z]/;
    // const spaceexp: RegExp =/[/\s/g, '']/

    if (control.value && nameRegexp.test(control.value)) {
      return { invalidName: true };
    }
  }
  
  onSubmit() {
    const header = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const params = new HttpParams()
        .append('username', this.loginform.value.username)
        .append('password', this.loginform.value.password)
        .append('client_id', this.clientId)
        .append('grant_type', 'phone_number_token')
        .append('client_secret', 'secret')
        .append('role','Patient')       
        this.Http.post(`${environment.Login_URL}`+`connect/token`,params, { headers: header }).subscribe((res:any)=>{        
        var userProfile: IProfile = res;
        console.log('login data :' +JSON.stringify(res))
        this.authProfile.setProfile(userProfile);
        this.notify.successmsg(res.firstName + " logged Successfully.");
        this.router.navigate(["/base/dashboard"]);       
        },
        // (error)=>{
        //   this.notify.errorsmsg(error)
        // }
        )
       
  }

  onChkChange(ob: MatCheckboxChange) {
    console.log("checked: " + ob.checked);
    localStorage.setItem('username',this.loginform.value.username)
    localStorage.setItem('password',this.loginform.value.password)        
    
 } 
 
  alert() {
    const dialogRef = this.dialog.open(AlertComponent,
      {
        width: "100%",
        maxWidth: "400px",
        height: "auto",
        hasBackdrop: true,
        maxHeight: "700px",
        panelClass: 'my-class',
        disableClose: true,
      });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      // setTimeout(() => {
      //   window.location.reload();
      // }, 2500);
    });
  }
  // openSnackBar(displaymessage: string, buttonText: string) {
  //   this._snackBar.openFromComponent(AlertComponent , {
  //     data:{
  //       message:displaymessage,
  //       buttonText:buttonText
  //     },
  //     horizontalPosition: this.horizontalPosition,
  //     verticalPosition: this.verticalPosition,
  //     panelClass:'Alert'
  //   });
  // }
}